var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('TopBarComponent',{attrs:{"max-width":1200}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }